import styled from "styled-components";

import industryBg from './../../assets/images/static/IndustryBg.png';
import restaurantBg from './../../assets/images/static/restaurantBg.png';
import pharmacyBg from './../../assets/images/static/pharmacyBg.png';
import bakeryBg from './../../assets/images/static/bakeryBg.png';
import retailBg from './../../assets/images/static/retailBg.png';
import industryMob from './../../assets/images/static/IndustryMob.png';
import restaurantMob from './../../assets/images/static/restaurantMob.png';
import pharmacyMob from './../../assets/images/static/pharmacyMob.png';
import bakeryMob from './../../assets/images/static/bakeryMob.png';
import retailMob from './../../assets/images/static/retailMob.png';

export const IndustrySection = styled.section`
  min-height: 720px;
  position: relative;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    min-height: unset;
  }
`;

export const ContentDiv = styled.div`
  background: url(${industryBg}) no-repeat top right;
  background-size: cover;
  align-items: center;
  display: flex;
  min-height: 710px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    min-height: 610px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    min-height: 520px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    min-height: 440px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    min-height: 380px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    min-height: 320px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    background: url(${industryMob}) no-repeat top center;
    background-size: cover;
  }
`;

export const HeadingTitle = styled.h2`
  color: ${({theme}) => theme.colors.basic};
  margin-left: 370px;
  width: 275px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin-left: 280px;
    width: 230px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    width: 210px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    margin-left: 210px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    margin-left: 180px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin-left: 80px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    margin-left: 60px;
    margin-top: 80px;
  }
  &:before {
    background-color: ${({theme}) => theme.colors.secondary};
  }
  &:after {
    background-color: ${({theme}) => theme.colors.basic};
  }
`;

export const ProductsWrapper = styled.div`
  display: flex;
  gap: 46px;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  width: 1560px;
  z-index: 9;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    gap: 40px;
    width: 1380px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    gap: 32px;
    width: 1180px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    gap: 28px;
    width: 1000px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    gap: 20px;
    width: 766px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    display: block;
    position: absolute;
    width: 290px;
    transform: translate(-50%, -12%);
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    width: 270px;
    transform: translate(-50%, -12%);
  }
`;

export const ProductItems = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  height: 173px;
  &.restaurant {
    background: url(${restaurantBg}) no-repeat center top;
    background-size: 139%;
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      background: url(${restaurantMob}) no-repeat center top;
      background-size: contain;
    }
  }
  &.pharmacy {
    background: url(${pharmacyBg}) no-repeat center top;
    background-size: 139%;
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      background: url(${pharmacyMob}) no-repeat center top;
      background-size: contain;
    }
  }
  &.bakery {
    background: url(${bakeryBg}) no-repeat center top;
    background-size: 139%;
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      background: url(${bakeryMob}) no-repeat center top;
      background-size: contain;
    }
  }
  &.retail {
    background: url(${retailBg}) no-repeat center top;
    background-size: 139%;
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      background: url(${retailMob}) no-repeat center top;
      background-size: contain;
    }
  }
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    height: 152px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    height: 132px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    height: 112px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    height: 86px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    height: 140px;
    margin-bottom: 16px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    height: 80px;
    margin-bottom: 12px;
  }
`;

export const ProductImage = styled.div`
  flex: 1;
  text-align: center;
`;

export const Image = styled.img`
  height: 60px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    height: 50px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    height: 42px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    height: 36px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    height: 28px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    height: 36px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    height: 34px;
  }
`;

export const ProductTitle = styled.h6`
  color: ${({theme}) => theme.colors.basic};
  text-transform: capitalize;
  flex: 1;
`;

export const IllutrationSection = styled.div`
  background-color: ${({theme}) => theme.colors.light};
  min-height: 232px;
  position: relative;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    min-height: 160px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    min-height: 140px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    min-height: 120px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    min-height: 600px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    min-height: 370px;
  }
`;

export const ImgIllustration = styled.img`
  left: -46px;
  position: absolute;
  top: 126px;
  width: 90px;
  z-index: -1;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    left: -40px;
    top: 111px;
    width: 80px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    left: -34px;
    top: 96px;
    width: 70px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    left: -29px;
    top: 80px;
    width: 60px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    left: -25px;
    top: 60px;
    width: 52px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    bottom: -5px;
    left: -20px;
    top: unset;
    width: 44px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    bottom: -3px;
    left: -15px;
    width: 32px;
  }
`;
